import React from "react";

import styles from "../DurationWarningModal/DurationWarningModal.module.scss";
import { BlockImageControlContainer } from "../../../../block/image-control/BlockImageControlContainer";

const ImageControlModalView = ({
    isVisible,
    hideModal,
    blockId,
    manualImageControl,
    ceremonyId,
    onImageControlChanged,
}) => {
    return (
        <div
            className={`modal ${styles.modal} ${isVisible ? "is-active" : ""}`}
        >
            <div className="modal-background" />
            <div className="modal-card">
                <BlockImageControlContainer
                    hideModal={hideModal}
                    blockId={blockId}
                    manualImageControl={manualImageControl}
                    ceremonyId={ceremonyId}
                    onImageControlChanged={onImageControlChanged}
                />
            </div>
        </div>
    );
};

export default ImageControlModalView;
